import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { EventParticipantList } from "./EventParticipantList";
import { ParticipantAdd } from "./ParticipantAdd";
import { ParticipantDaikinAdd } from "./ParticipantDaikinAdd";
import { ParticipantSendMail } from "./ParticipantSendMail";
import { ParticipantSendInvitation } from "./ParticipantSendInvitation";
import { ParticipantSendUpdateInvitation } from "./ParticipantSendUpdateInvitation";
import { ParticipantSendReminderMail } from "./ParticipantSendReminderMail";

function EventParticipantCard(props) {
  const { t } = useTranslation();
  const [visibleParticipantAdd, setVisibleParticipantAdd] = useState(false);
  const [visibleDaikinParticipantAdd, setVisibleDaikinParticipantAdd] =
    useState(false);
  const [visibleSendMail, setVisibleSendMail] = useState(false);
  const [visibleSendInvitation, setVisibleSendInvitation] = useState(false);
  const [visibleSendUpdateInvitation, setVisibleSendUpdateInvitation] =
    useState(false);
  const [visibleSendReminderMail, setVisibleSendReminderMail] = useState(false);
  const [reminderMailDataState, setReminderMailDataState] = useState(null);
  const [isAdded, setIsAdded] = useState(false);

  function toggleDialogAddParticipant() {
    setVisibleParticipantAdd(!visibleParticipantAdd);
  }
  function toggleDialogAddDaikinParticipant() {
    setVisibleDaikinParticipantAdd(!visibleDaikinParticipantAdd);
  }
  function toggleDialogSendMail() {
    setVisibleSendMail(!visibleSendMail);
  }

  function toggleDialogSendInvitation() {
    setVisibleSendInvitation(!visibleSendInvitation);
  }

  function toggleDialogSendUpdateInvitation() {
    setVisibleSendUpdateInvitation(!visibleSendUpdateInvitation);
  }

  function toggleDialogSendReminderMail(dataState) {
    if (dataState?.filter) {
      setReminderMailDataState(dataState);
      setVisibleSendReminderMail(true);
      return;
    }
    setVisibleSendReminderMail(false);
  }

  return (
    <Fragment>
      {visibleParticipantAdd ? (
        <ParticipantAdd
          toggleDialog={toggleDialogAddParticipant}
          title={t("add_participant_external")}
          event={props.event}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
        ></ParticipantAdd>
      ) : (
        ""
      )}
      {visibleDaikinParticipantAdd ? (
        <ParticipantDaikinAdd
          toggleDialog={toggleDialogAddDaikinParticipant}
          title={t("add_participant_daikin")}
          event={props.event}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
        ></ParticipantDaikinAdd>
      ) : (
        ""
      )}
      {visibleSendMail ? (
        <ParticipantSendMail
          toggleDialog={toggleDialogSendMail}
          title={t("send_mail_to_participants")}
          event={props.event}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
        ></ParticipantSendMail>
      ) : (
        ""
      )}
      {visibleSendInvitation ? (
        <ParticipantSendInvitation
          toggleDialog={toggleDialogSendInvitation}
          title={t("send_calendar_invitation")}
          event={props.event}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
        ></ParticipantSendInvitation>
      ) : (
        ""
      )}
      {visibleSendUpdateInvitation ? (
        <ParticipantSendUpdateInvitation
          toggleDialog={toggleDialogSendUpdateInvitation}
          title={t("send_update_calendar_invitation")}
          event={props.event}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
        ></ParticipantSendUpdateInvitation>
      ) : (
        ""
      )}
      {visibleSendReminderMail ? (
        <ParticipantSendReminderMail
          toggleDialog={toggleDialogSendReminderMail}
          title={t("send_reminder_mail")}
          event={props.event}
          isAdded={isAdded}
          setIsAdded={setIsAdded}
          dataState={reminderMailDataState}
        ></ParticipantSendReminderMail>
      ) : (
        ""
      )}
      <EventParticipantList
        event={props.event}
        toggleDialogAddParticipant={toggleDialogAddParticipant}
        toggleDialogAddDaikinParticipant={toggleDialogAddDaikinParticipant}
        toggleDialogSendMail={toggleDialogSendMail}
        toggleDialogSendInvitation={toggleDialogSendInvitation}
        toggleDialogSendUpdateInvitation={toggleDialogSendUpdateInvitation}
        toggleDialogSendReminderMail={toggleDialogSendReminderMail}
        isAdded={isAdded}
        setIsAdded={setIsAdded}
      ></EventParticipantList>
    </Fragment>
  );
}

export { EventParticipantCard };
